import { render } from "./QuadrantPage.vue?vue&type=template&id=66f3892a"
const script = {}

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/quadrant/QuadrantPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "66f3892a"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('66f3892a', __exports__)) {
    api.reload('66f3892a', __exports__)
  }
  
  module.hot.accept("./QuadrantPage.vue?vue&type=template&id=66f3892a", () => {
    api.rerender('66f3892a', render)
  })

}


export default __exports__